import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './ui/Button';
import { trackAddToCart } from '../utils/metaPixel';
export function StickyNav() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#0F0F14]/80 backdrop-blur-xl border-b border-white/5 py-3' : 'bg-transparent py-5'}`} data-id="element-233">
      <div className="max-w-6xl mx-auto px-6 flex items-center justify-between" data-id="element-234">
        <div className="font-heading font-bold text-white text-sm md:text-base tracking-tight" data-id="element-235">
          No Contact, <span className="text-gradient" data-id="element-236">Sin</span> Recaídas
        </div>

        <Button onClick={scrollToPricing} className="px-5 py-2 text-sm md:text-base" data-id="element-237">
          <span className="hidden md:inline" data-id="element-238">Quiero empezar →</span>
          <span className="md:hidden" data-id="element-239">Empezar →</span>
        </Button>
      </div>
    </motion.nav>;
}